import React from 'react'
import styled from 'styled-components'
import Heart from '../images/heart.svg'

const FooterContainer = styled.footer`
  ${tw`flex flex-col md:flex-row justify-center md:justify-between items-center w-full px-8 md:px-24 fixed pin-b py-16`};
  z-index: 50;
  background-color: #f0f0f0;
  box-sizing: border-box;
`

const PortfolioLink = styled.a`
  ${tw`relative no-underline text-black  md:text-md `}

  &:after {
    content: '';
    ${tw`bg-black`}
    display: inline-block;
    width: 100%;
    height: 1px;
    position: absolute;
    top: 1.375em;
    left: 0;
    z-index: -1;
    transition: 0.2s linear;
  }

  &:hover:after {
    top: 0.875em;
  }
`

const MadeWithLove = styled.p`
  ${tw`pt-4 m-0 md:p-0`};
`

const HeartIcon = styled.img`
  vertical-align: middle;
`

const Footer = () => (
  <FooterContainer>
    <PortfolioLink href="https://danieldomanski.com">
      danieldomanski.com
    </PortfolioLink>
    <MadeWithLove>
      made with <HeartIcon src={Heart} /> to Szczecin
    </MadeWithLove>
  </FooterContainer>
)

export default Footer
